const assign = require("object-assign");

/////////////////////////////////
// Group items by product id and price
/////////////////////////////////

function sumExtras() {
	let extras = {};

	Array.prototype.slice.call(arguments).forEach(prices => {
		Object.keys(prices).forEach(key => {
			if (extras[key] == undefined) {
				extras[key] = 0.0;
			}

			extras[key] += prices[key];
		});
	});

	return extras;
}

function groupProductItems(items) {
	// NOTE: We removed grouping for now and we are going to
	// list the products one by one instead
	return items;

	let dictionary = {};

	items.forEach(raw => {
		const id = raw.product;
		const price = raw.price;

		if (dictionary[id] == undefined) {
			dictionary[id] = {};
		}

		if (dictionary[id][price] == undefined) {
			dictionary[id][price] = assign({}, raw, {
				id: [raw.id],
				amount: 1,
				totalPrice: raw.price,
				totalExtras: assign({}, raw.extras)
			});
		}
		else {
			dictionary[id][price].id.push(raw.id);
			dictionary[id][price].amount += 1;
			dictionary[id][price].totalPrice += raw.price;
			dictionary[id][price].totalExtras = sumExtras(
				dictionary[id][price].totalExtras,
				raw.extras
			);
		}
	});

	let groupedItems = [];

	Object.keys(dictionary).forEach(id => {
		Object.keys(dictionary[id]).forEach(price => {
			groupedItems.push(dictionary[id][price]);
		});
	});

	return groupedItems;
}

module.exports = {
	groupProductItems
};